export default {
  ATTENTE: 0,
  ENCOURS: 1,
  ARRETER: 2,
  TERMINER: 3,
};
